import { Tag } from '@/components';
import type { FC } from 'react';
import type { z } from 'zod';
import {
  WorkflowStatusModifier,
  type workflowStatusType,
} from '../../models/workflow';

type Props = {
  status: z.infer<typeof workflowStatusType>;
};

export const WorkflowStatusTag: FC<Props> = ({ status }) => {
  return (
    <Tag color={status === 'approved' ? 'green' : 'default'}>
      {WorkflowStatusModifier[status]}
    </Tag>
  );
};
